import React from "react";
import { createRoot, Root } from "react-dom/client";
import "@apps/Shared/translation/i18n";
import EditablePdf from "@sharedComponents/EditablePdf";
import { EditablePdfField } from "@sharedComponents/EditablePdf/types";
import OrderAssetModal from "@sharedComponents/OrderAssetModal";
import { OpenFlyerEditorParams } from "@features/Components/DownloadAssetsBlock/Scripts/types";

let editablePdfRoot: Root | null = null;
let orderAssetModalRoot: Root | null = null;

export function openFlyerEditor(editablePdfProps: OpenFlyerEditorParams) {
  const mount = document.getElementById("editable-pdf-root") as HTMLElement | null;
  if (!mount) return;

  mount.style.display = "block";

  editablePdfRoot = createRoot(mount);

  editablePdfRoot.render(
    <EditablePdf
      {...editablePdfProps}
      onClose={() => {
        mount.style.display = "none";
        editablePdfRoot?.unmount();
        editablePdfRoot = null;
      }}
    />
  );
}

function openOrderAssetModal(heading: string, description: string) {
  const mount = document.getElementById("order-asset-modal-root") as HTMLElement | null;
  if (!mount) return;

  orderAssetModalRoot?.unmount();
  orderAssetModalRoot = createRoot(mount);

  orderAssetModalRoot.render(
    <OrderAssetModal
      heading={heading}
      description={description}
      onClose={() => {
        orderAssetModalRoot?.unmount();
        orderAssetModalRoot = null;
      }}
    />
  );
}

const editButtons = Array.from(
  document.querySelectorAll(".asset__item--edit-button")
) as HTMLButtonElement[];

editButtons.forEach(btn => {
  btn.addEventListener("click", () => {
    const heading = btn.dataset.heading || "";
    const fileUrl = btn.dataset.fileurl;
    const previewUrl = btn.dataset.previewurl;
    const previewImageAlt = btn.dataset.previewimagealt || "";
    const b64 = btn.dataset.editablefields;

    if (!fileUrl || !b64 || !previewUrl) return;

    const json = atob(b64);
    const fields: EditablePdfField[] = JSON.parse(json);

    openFlyerEditor({
      heading,
      fileUrl,
      previewUrl,
      previewImageAlt,
      fields
    });
  });
});

document.addEventListener("click", event => {
  const target = event.target as HTMLElement | null;
  const button = target?.closest(".asset__item--order-button") as HTMLButtonElement | null;

  if (!button) return;

  const heading = button.dataset.heading || "";
  const description = button.dataset.description || "";

  openOrderAssetModal(heading, description);
});
